import { roles } from '@nxsys/store/constants';
import AttachmentOrdersReport from '../../../modules/reports/attachmentOrder/listing/AttachmentOrdersReport';

export const attachmentOrdersReportsConfig = [
  {
    permittedRole: [roles.admin, roles.employer],
    path: '/reports/attachment-orders-report',
    element: <AttachmentOrdersReport />,
  },
];
